import { Card } from "$components/card";
import { styled } from "@material-ui/core";
import type { ReactNode } from "react";

const Icon = styled("div")(({ theme }) => ({
  border: "2px solid transparent",
  padding: theme.spacing(1),
  backgroundColor: "orange",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  aspectRatio: "1/1",
  transition: "opacity 0.2s ease-in-out",
  opacity: 0.5,
  "&:hover,&:active": {
    transition: "opacity 0.2s ease-in-out",
    opacity: 1,
    // Selects the direct adjacent sibling of the icon, aka the info card.
    "& + div": {
      transition: "left 0s ease 0s",
      left: 80,
    },
  },
  "& > *": {
    width: 48,
    height: 48,
  },
}));

const Row = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  gap: theme.spacing(1),
  alignItems: "end",
}));

const InfoCard = styled(Card)({
  position: "absolute",
  bottom: 0,
  minWidth: "min(30rem, 65vw)",
  maxWidth: "min(40rem, 65vw)",
  // Delay for mouse exit to allow you to click the link
  transition: "left 0s ease 3s",
  // Hack to just get it off the screen
  left: -100000,
});

export const GlobalAppIssue: FCwC<{ icon: ReactNode }> = ({
  icon,
  children,
}) => {
  return (
    <Row>
      <Icon tabIndex={0}>{icon}</Icon>
      <InfoCard>{children}</InfoCard>
    </Row>
  );
};
